import React from 'react';

interface MediaIconProps {
  isActive?: boolean;
  className?: string;
}

const MediaIcon: React.FC<MediaIconProps> = ({ isActive = false, className = 'mr-2' }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    className={className} 
    width="18" 
    height="18" 
    viewBox="0 0 24 24" 
    fill="none" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect 
      width="18" 
      height="18" 
      x="3" 
      y="3" 
      rx="2" 
      ry="2" 
      stroke={isActive ? "#4F46E5" : "#4B5563"}
      fill={isActive ? "#EEF2FF" : "none"}
    />
    <circle 
      cx="9" 
      cy="9" 
      r="2" 
      stroke={isActive ? "#4F46E5" : "#4B5563"}
      fill={isActive ? "#1FEDCC" : "none"}
    />
    <path 
      d="M21 15L16 10l-5 5" 
      stroke={isActive ? "#4F46E5" : "#4B5563"}
    />
  </svg>
);

export default MediaIcon;
